import { Component, OnInit, Input } from '@angular/core';
import { IDynamicComponent } from '../../../dynamic-component/IDynamicComponent';
import { Observable } from 'rxjs';

@Component({
  selector: 'ps-data-grid-editable-row',
  templateUrl: './data-grid-editable-row.component.html',
  styleUrls: ['./data-grid-editable-row.component.css']
})
export class DataGridEditableRowComponent implements OnInit {

  @Input() model: any;
  @Input() dynamicComponent: IDynamicComponent;

  constructor() { 

  }

  ngOnInit() {

  }
}
